class ThemeManager {
  constructor(mediaQuery) {
    this.mediaQuery = mediaQuery
    this.mediaQuery.addEventListener('change', this.handleMediaQueryChange.bind(this))
    this.handleMediaQueryChange(this.mediaQuery)
  }

  handleMediaQueryChange(mq) {
    const body = document.getElementsByTagName('body')[0]
    const html = document.documentElement
    const theme = window.$global.theme

    if (theme === 'auto') {
      if (mq.matches) {
        body.classList.add('dark_mode')
        html.setAttribute('data-theme', 'dark')
      } else {
        body.classList.remove('dark_mode')
        html.setAttribute('data-theme', 'light')
      }
    } else if (theme === 'dark') {
      body.classList.add('dark_mode')
      html.setAttribute('data-theme', 'dark')
    } else {
      body.classList.remove('dark_mode')
      html.removeAttribute('data-theme')
    }
  }

  dispose() {
    this.mediaQuery.removeEventListener('change', this.handleMediaQueryChange.bind(this))
  }
}

export default ThemeManager
